export const normalizePhoneForValidation = (phone: string) => {
  return String(phone || "").replace(/\s+/g, "").replace(/\+/g, "");
};

export const isValidSaudiPhone = (phone: string) => {
  const normalized = normalizePhoneForValidation(phone);
  return /^(966|0)?5\d{8}$/.test(normalized);
};

export const isValidOtpCode = (otp: string) => {
  return /^\d{4,10}$/.test(String(otp || "").trim());
};
